module.exports = __webpack_public_path__ + "img/basketball_c1.c5e8155b.svg";